/* eslint-disable no-undef */
import * as auth from '../helpers/auth';
import config from '../config';

export const HEADERS = () => {
  return {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'token': auth.accessToken()
    }
  };
};

export const HEADERS_BLOB = () => {
  return {
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'token': auth.accessToken()
    },
    responseType: 'blob'
  };
};

export function TOKEN() {
  return auth.accessToken();
}

export function USER_AUTH_OBJECT() {
  return auth.currentUser();
}

const { HOST, VERSION } = config.api;
export const API_URL = HOST + VERSION;

export const API_SUCCESS = 200;

export const API_ACCESS_DENIED = 403;

export const LOGIN_SUCCESS = 'AUTH_SUCCESS';

export const LOGIN_FAILURE = 'AUTH_FAILURE';

export const LOGIN_REQUEST = 'AUTH_REQUEST';

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

export const AUTH = 'AUTH';

export const MESSAGE_PREFIX = 'LLQ HRMS!';

export const MESSAGES = {
  ERROR_COLLECTING_DATA: 'Lỗi lấy dữ liệu từ: ',

  NOT_FOUND_DATA: 'Không tìm được dữ liệu!',

  ACCESS_DENIED: 'Bạn không có quyền truy cập trang này!',

  NO_DOCUMENT_SELECTED: 'Không có dữ liệu nào được chọn',

  ERROR_DELETE_DOCUMENT: 'Có lỗi xảy ra khi xoá dữ liệu',

  ERROR_DELETE_BATCH_DOCUMENT: 'Có lỗi xảy ra khi xoá hàng loạt dữ liệu',

  ERROR_UPDATE: 'Lỗi cập nhật dữ liệu ',

  ERROR_CREATE: 'Có lỗi xảy ra khi tạo mới ',

  ERROR_EXPORT: 'Tải file excel thất bại',

  ERROR_DOWNLOAD: 'Tải dữ liệu thất bại',

  FILE_NOT_SELECTED: 'Vui lòng chọn một tệp trước khi tải lên.',

  ERROR_IMPORT: 'Có lỗi xảy ra trong quá trình tải file lên.'
};

export const USER_AUTH = 'user.auth';

export const REDIRECT_PATH_PROFILE = '/app/profile';

export const REDIRECT_PATH_LOGIN = '/login';

export const REDIRECT_PATH_FORBIDDEN = '/app/403';

export const ELOGIN = 'elogin';

export const EMPTY_TEXT = 'Không có dữ liệu';

export const RESET_REDIRECT_FORBIDDEN = 'RESET_REDIRECT_FORBIDDEN';

export const REDIRECT_TO_FORBIDDEN = 'REDIRECT_TO_FORBIDDEN';

